export class ParametroRegional {
    nome: string;
    valor: string;
    usuario: string;
    regiao: string;

    constructor(nome: string, valor: string, usuario: string, regiao: string) {
        this.nome = nome;
        this.valor = valor;
        this.usuario = usuario;
        this.regiao = regiao;
    }

}
